<template>
  <div class="Home">
    <div v-if="!emailSent">
      <h5>
        {{ $t("sending...") }}
      </h5>
      <img src="img/loading.svg" />
    </div>
    <div v-else>
      <img src="img/sent.svg" width="130px" />
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import { mapState } from "vuex";
import { writeUserMail } from "@/utils/firebase";
import { closeMe } from "@/utils";

export default {
  name: "Home",

  components: {},

  data() {
    return {
      emailSent: false,

      title: "",
      text: "",
      url: "",

      send: "",
    };
  },

  computed: {
    ...mapState("userData", ["authSettled", "loggedIn", "user", "userData"]),
  },

  methods: {
    waitAuthSettled() {
      if (this.authSettled && (!this.send || this.loggedIn)) {
        setTimeout(() => {
          this.triggerSend();
        }, 50);
      } else {
        setTimeout(() => {
          this.waitAuthSettled();
        }, 100);
      }
    },

    async sendMail() {
      const email = {
        subject: this.title || this.text,
        body: this.text + "\n" + this.url,
      };
      await writeUserMail(email);
      return null;
    },

    async triggerSend() {
      let newMailToBeSent = !this.loggedIn;

      let mailData = {
        title: this.title,
        text: this.text,
        url: this.url,
      };

      this.$store.commit("mail/mailToBeSentMutation", newMailToBeSent);
      this.$store.commit("mail/mailDataMutation", mailData);

      if (this.loggedIn) {
        await this.sendMail();
        this.emailSent = true;
        this.closeMe();
      } else {
        this.$router.push({ name: "Login" });
      }
    },

    closeMe() {
      setTimeout(() => {
        closeMe();

        setTimeout(() => {
          this.$router.push({
            path: "/",
            query: {
              closeme: "true",
            },
          });
        }, 100);
      }, 500);
    },
  },

  mounted() {
    this.title = this.$route.query.title || "";
    this.text = this.$route.query.text || "";
    this.url = this.$route.query.url || "";

    this.send = this.$route.query.send || "";

    this.waitAuthSettled();
  },
};
</script>

<style lang="scss" scoped>
.Home {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
